






























import { Component, Inject, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ProvidedNavParam } from './types';

const cssPrefix = 'sw-nav-section-divider';

@Component
export default class SwNavSectionDivider extends SwExtendedVue {
  /**
   * I was trying to use functional component and leverage the provided props
   * via sw-nav in the functional component. However, it seems there is an unresolved
   * bug of Vue for this usage, so I have to fallback to use normal component for now:
   * https://github.com/vuejs/vue/issues/5837
   */
  // functional: true,

  cssPrefix = cssPrefix;

  @Prop({ type: String, required: true })
  title: string;

  @Inject()
  navParam: ProvidedNavParam;
}
